import { createAsyncThunk } from "@reduxjs/toolkit"

import { IAddIssuerDocument } from "../../types/DocumentManagement"
import { IssuerDocumentModel } from "../../generated/api"

import {
  deleteDocument,
  getIssuerDocumentFile,
  getPendingDocuments,
  getPendingDocumentsForIssuer,
  patchIssuerDocumentStatus,
  postIssuerDocument,
  putIssuerDocument
} from "./cruds"

const ACTION_TYPE_PARENT = "IssuerDocument"

export const fetchPendingDocuments = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/fetchPendingDocuments`,
  async ({ requestHeaders }: any, { rejectWithValue }) => {
    try {
      const response = await getPendingDocuments(requestHeaders)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchPendingDocumentsForIssuer = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/fetchPendingDocumentsForIssuer`,
  async ({ requestHeaders, issuerId }: any, { rejectWithValue }) => {
    try {
      const response = await getPendingDocumentsForIssuer(issuerId, requestHeaders)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const createIssuerDocument = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/createIssuerDocument`,
  async (payload: IAddIssuerDocument, { rejectWithValue }) => {
    try {
      const response = await postIssuerDocument(payload)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, errors : err.response.data?.errors, data : err.response.data })
    }
  }
)

export const updateIssuerDocument = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/updateIssuerDocument`,
  async (payload: IssuerDocumentModel, { rejectWithValue }) => {
    try {
      const response = await putIssuerDocument(payload)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, errors : err.response.data?.errors })
    }
  }
)

// * updates issuer document status
export const updateIssuerDocumentStatus = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/updateIssuerDocumentStatus`,
  async ({documentId, params}: any, { rejectWithValue }) => {
    try {
      const response = await patchIssuerDocumentStatus(documentId, params)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const downloadIssuerDocument = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/downloadIssuerDocument`,
  async ({ documentId, onDownloadProgress }: any, { rejectWithValue }) => {
    try {
      const response = await getIssuerDocumentFile(documentId, onDownloadProgress)
      return response
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      // responseType on this endpoint is set to blob so errors are returned as blob
      // convert the blob to string to display the error on the UI
      return rejectWithValue({ status: err.response.status, code: err.code, message: await err.response.data.text() })
    }
  }
)

export const deleteIssuerDocument = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/deleteIssuerDocument`,
  async (documentId: string, { rejectWithValue }) => {
    try {
      const response = await deleteDocument(documentId)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err?.response?.data })
    }
  }
)
